export default "__VITE_ASSET__BHvgRkB2__"